import config from '@config';
import { EMPTY_ARR } from '@constants';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from './utils';

const BASE_PATHNAME = 'vocabulary';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();
  const getByIds = ({ ids }) => Promise.all(ids.map((id) => getById({ id })));
  const getAllByLanguage = ({ languageCode }) => dataSource.get(`${BASE_PATHNAME}/${languageCode}/all`).json();

  const remove = ({ id }) => dataSource.delete(`${BASE_PATHNAME}/${id}`);

  const create = ({ values }) => dataSource.post(BASE_PATHNAME, { json: { ...values } }).json();

  const update = ({ vocabulary, languageCode }) => {
    if (vocabulary.value) {
      return dataSource.put(`${BASE_PATHNAME}`, { json: { ...vocabulary, languageCode } }).json();
    }
    return null;
  };

  const publishAll = ({ vocabulary, languageCode }) => {
    if (languageCode) {
      return dataSource
        .post(`${BASE_PATHNAME}/publish/${languageCode}`, { json: { ...vocabulary, language: languageCode } })
        .json();
    }
    return null;
  };

  const updateAll = ({ values, languageCode }) => {
    const vocabularies = values?.vocabularies || EMPTY_ARR;
    return Promise.all(
      vocabularies.map((vocabulary) => {
        if (vocabulary.value && vocabulary.isUpDated === 'true') {
          update({ vocabulary, languageCode });
        }
        return null;
      }),
    );
  };

  const saveBeforePublish = ({ values, languageCode }) => {
    const vocabularies = values?.vocabularies || EMPTY_ARR;
    return Promise.all(
      vocabularies.map((vocabulary) => {
        if (vocabulary.value && vocabulary.isUpDated === 'true') {
          return update({ vocabulary, languageCode });
        }
        return false;
      }),
    );
  };

  // const save = async ({ id, values, languageCode }) => (id ? updateAll({ values, languageCode }) : create({ values }));
  const save = async ({ values, languageCode }) => updateAll({ values, languageCode });

  const publish = async ({ values, languageCode }) => {
    const pub = await saveBeforePublish({ values, languageCode });
    if (pub) {
      publishAll({ languageCode });
    }
    return false;
  };

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
    }),

    getById,

    getByIds,

    getAllByLanguage,

    remove,

    create,

    updateAll,

    save,

    publish,

    getEmptyList: getDefaultEmptyList,
  };
};
